import React, { useState, useRef, useEffect, useContext  } from "react";
import { useHistory } from "react-router-dom";
import { Icon, Image } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux'
import dual_box from "../assets/home/dual_box.png";
import close from "../assets/home//close.svg";
import { CopyToClipboard } from 'react-copy-to-clipboard';

const ReferearnScreen = () => {

    const [copy, setCopy] = useState(false)
    const { t, i18n } = useTranslation();
    const userDetails = useSelector((state) => state.user.userDetails)
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const HandleClick = () => {

      setCopy(true);

    }




    return (
        <>
            <div className="container_bg clearall">
                <div className="referearn">
                    <div className="crous">
                         {/* <Icon name='x' size='large' /> */}
                         <img   src={close}  onClick = { ()=> history.push('/')  }  />
                    </div>
                    <div className="refer">
                        <h4>{t("referearn.titel1")} <span>{t("referearn.titel2")}</span> </h4>
                        <p>{t("referearn.consectetur")}</p>
                    </div>
                     {/* <div className="copy"> */}

                    {/* <h6> click to copy  </h6> */}
                     {/* </div> */}
                     <div className="clipboard"  style={{ display: (copy ? 'block' : 'none') }} > 
                <p>copied</p>
                
                 </div>


                    <div className="bit_sec">

                        <div className="bit">
                            <h5>{userDetails?.referalCode}</h5>
                        </div>

                        <div className="bit_img" onClick={ ()=> HandleClick() }>
                            <CopyToClipboard text={userDetails?.referalCode}>
                                
                                <img className="dual_img" src={dual_box} />
                                </CopyToClipboard>
                        </div>

                    </div>

                    <h6>{t("referearn.para1")} <span>{t("referearn.para2")}</span></h6>
                   

                </div>

                
            </div>
            
          


        </>
    );
};



export default ReferearnScreen;
